module.exports = __webpack_public_path__ + "static/media/product-small-04.6ef1dc4a.png";